// Map of all regular products and their respective plants/price
const regularProductMap = new Map([
  ["Crimper", new Map([
    ["Boucherville", 600],
    ["Mississauga", 600],
    ["Calgary", 600],
  ])],
]);

// deckMap object is a collection of all deck variants and their respective weight/price/id
// First level is the title
// title = document.getElementById('product_title').textContent;
//
// Second level is the width, manufacturing plants and description
// description = document.getElementById("SingleOptionSelector-0").value;
//
// Third level is the weight and price
const deckMap = new Map([
  ["FormP3012", new Map([
    ["width", 30],
    ["plants", [
      "Boucherville"
    ]],
    ["22ga. Galvanized (G90)", new Map([
      ["weight", 1.64],
      ["price", 3.01]
    ])],
  ])],
  ["CompositeP3606P3615", new Map([
    ["width", 36],
    ["plants", [
      "Boucherville"
    ]],
    ["22ga. Galvanized (G90)", new Map([
      ["weight", 1.68],
      ["price", 2.79]
    ])],
    ["20ga. Galvanized (G90)", new Map([
      ["weight", 1.98],
      ["price", 3.21]
    ])],
    ["18ga. Galvanized (G90)", new Map([
      ["weight", 2.62],
      ["price", 4.05]
    ])],
    ["16ga. Galvanized (G90)", new Map([
      ["weight", 3.23],
      ["price", 4.95]
    ])],
    ["22ga. Light zinc coat (A25)", new Map([
      ["weight", 1.62],
      ["price", 2.58]
    ])],
    ["20ga. Light zinc coat (A25)", new Map([
      ["weight", 1.92],
      ["price", 3.00]
    ])],
    ["18ga. Light zinc coat (A25)", new Map([
      ["weight", 2.56],
      ["price", 3.84]
    ])],
    ["16ga. Light zinc coat (A25)", new Map([
      ["weight", 3.17],
      ["price", 4.74]
    ])],  
  ])],
  ["CompositeP3623", new Map([
    ["width", 36],
    ["plants", [
      "Boucherville"
    ]],
    ["20ga. Galvanized (G90)", new Map([
      ["weight", 1.96],
      ["price", 3.19]
    ])],
    ["18ga. Galvanized (G90)", new Map([
      ["weight", 2.59],
      ["price", 4.02]
    ])],
    ["16ga. Galvanized (G90)", new Map([
      ["weight", 3.21],
      ["price", 4.95]
    ])],
    ["20ga. Light zinc coat (A25)", new Map([
      ["weight", 1.90],
      ["price", 2.98]
    ])],
    ["18ga. Light zinc coat (A25)", new Map([
      ["weight", 2.53],
      ["price", 3.81]
    ])],
    ["16ga. Light zinc coat (A25)", new Map([
      ["weight", 3.16],
      ["price", 4.74]
    ])],
  ])],
  ["CompositeP2432", new Map([
    ["width", 24],
    ["plants", [
      "Calgary"
    ]],
    ["20ga. Galvanized (G90)", new Map([
      ["weight", 2.18],
      ["price", 4.66]
    ])],
    ["18ga. Galvanized (G90)", new Map([
      ["weight", 2.90],
      ["price", 5.92]
    ])],
    ["16ga. Galvanized (G90)", new Map([
      ["weight", 3.59],
      ["price", 7.24]
    ])],
    ["20ga. Light zinc coat (A25)", new Map([
      ["weight", 2.12],
      ["price", 4.34]
    ])],
    ["18ga. Light zinc coat (A25)", new Map([
      ["weight", 2.83],
      ["price", 5.61]
    ])],
    ["16ga. Light zinc coat (A25)", new Map([
      ["weight", 3.52],
      ["price", 6.93]
    ])],
  ])],
   ["CompositeLF3", new Map([
    ["width", 36],
    ["plants", [
      "Boucherville", "Mississauga"
    ]],
    ["20ga. Galvanized (G90)", new Map([
      ["weight", 2.13],
      ["price", 3.52]
    ])],
    ["18ga. Galvanized (G90)", new Map([
      ["weight", 2.82],
      ["price", 4.47]
    ])],
    ["16ga. Galvanized (G90)", new Map([
      ["weight", 3.48],
      ["price", 5.45]
    ])],
    ["20ga. Light zinc coat (A25)", new Map([
      ["weight", 2.1],
      ["price", 3.21]
    ])],
    ["18ga. Light zinc coat (A25)", new Map([
      ["weight", 2.76],
      ["price", 4.15]
    ])],
    ["16ga. Light zinc coat (A25)", new Map([
      ["weight", 3.41],
      ["price", 5.13]
    ])],
  ])],
   ["CompositeLF2", new Map([
    ["width", 36],
    ["plants", [
      "Boucherville"
    ]],
    ["20ga. Galvanized (G90)", new Map([
      ["weight", 1.96],
      ["price", 3.19]
    ])],
    ["18ga. Galvanized (G90)", new Map([
      ["weight", 2.59],
      ["price", 4.02]
    ])],
    ["16ga. Galvanized (G90)", new Map([
      ["weight", 3.21],
      ["price", 4.95]
    ])],
    ["20ga. Light zinc coat (A25)", new Map([
      ["weight", 1.90],
      ["price", 2.98]
    ])],
    ["18ga. Light zinc coat (A25)", new Map([
      ["weight", 2.53],
      ["price", 3.81]
    ])],
    ["16ga. Light zinc coat (A25)", new Map([
      ["weight", 3.16],
      ["price", 4.74]
    ])],
  ])],
  ["RoofP3606P3615", new Map([
    ["width", 36],
    ["plants", [
      "Boucherville"
    ]],
    ["22ga. Galvanized (G90)", new Map([
      ["weight", 1.68],
      ["price", 2.79]
    ])],
    ["20ga. Galvanized (G90)", new Map([
      ["weight", 1.98],
      ["price", 3.21]
    ])],
    ["18ga. Galvanized (G90)", new Map([
      ["weight", 2.62],
      ["price", 4.05]
    ])],
    ["16ga. Galvanized (G90)", new Map([
      ["weight", 3.23],
      ["price", 4.95]
    ])],
    ["22ga. Light zinc coat (A25)", new Map([
      ["weight", 1.62],
      ["price", 2.58]
    ])],
    ["20ga. Light zinc coat (A25)", new Map([
      ["weight", 1.92],
      ["price", 3.00]
    ])],
    ["18ga. Light zinc coat (A25)", new Map([
      ["weight", 2.56],
      ["price", 3.84]
    ])],
    ["16ga. Light zinc coat (A25)", new Map([
      ["weight", 3.17],
      ["price", 4.74]
    ])],
  ])],
  ["RoofP2404P2436", new Map([
    ["width", 24],
    ["plants", [
      "Boucherville", "Calgary"
    ]],
    ["22ga. Galvanized (G90)", new Map([
      ["weight", 2.35],
      ["price", 4.01]
    ])],
    ["20ga. Galvanized (G90)", new Map([
      ["weight", 2.76],
      ["price", 4.62]
    ])],
    ["18ga. Galvanized (G90)", new Map([
      ["weight", 3.64],
      ["price", 5.81]
    ])],
    ["16ga. Galvanized (G90)", new Map([
      ["weight", 4.5],
      ["price", 7.08]
    ])],
    ["22ga. Light zinc coat (A25)", new Map([
      ["weight", 2.26],
      ["price", 3.70]
    ])],
    ["20ga. Light zinc coat (A25)", new Map([
      ["weight", 2.68],
      ["price", 4.31]
    ])],
    ["18ga. Light zinc coat (A25)", new Map([
      ["weight", 3.56],
      ["price", 5.49]
    ])],
    ["16ga. Light zinc coat (A25)", new Map([
      ["weight", 4.42],
      ["price", 6.77]
    ])],
  ])],
]);

// girtPriceMap object is a collection of all girt variants price and weight
// It is made separately from girtIdMap to avoid cluttering
// First level is the unit type, if metric is selected (1) or not (0)
//
// Second level is a list of metric sizes
//
// Third level is a list of designations
//
// Fourth level is the price and weight associated to the designation
const girtPriceMap = new Map([
  ['PurlinsGirtsC', new Map([
    ["plants", ["Boucherville"]],
    [1, new Map([
      ['C152', new Map([
        ['C152 x 4.3 (152S70-144M)', new Map([
          ['price', 5.67],
          ['weight', 2.9],
        ])],
        ['C152 x 5.2 (152S70-181M)', new Map([
          ['price', 6.59],
          ['weight', 3.5],
        ])],
        ['C152 x 6.0 (152S70-218M)', new Map([
          ['price', 7.11],
          ['weight', 4],
        ])],
        ['C152 x 7.0 (152S70-254M)', new Map([
          ['price', 8.01],
          ['weight', 4.7],
        ])],
        ['C152 x 8.3 (152S70-290M)', new Map([
          ['price', 9.06],
          ['weight', 5.6],
        ])],
        ['C152 x 8.9 (152S70-326M)', new Map([
          ['price', 9.78],
          ['weight', 6],
        ])],
      ])],
      ['C203', new Map([
        ['C203 x 5.1 (203S70-144M)', new Map([
          ['price', 6.35],
          ['weight', 3.4],
        ])],
        ['C203 x 6.0 (203S70-181M)', new Map([
          ['price', 7.06],
          ['weight', 4],
        ])],
        ['C203 x 7.0 (203S70-218M)', new Map([
          ['price', 8.08],
          ['weight', 4.7],
        ])],
        ['C203 x 8.0 (203S70-254M)', new Map([
          ['price', 8.94],
          ['weight', 5.4],
        ])],
        ['C203 x 9.1 (203S70-290M)', new Map([
          ['price', 9.67],
          ['weight', 6.1],
        ])],
        ['C203 x 10.6 (203S70-326M)', new Map([
          ['price', 11.28],
          ['weight', 7.1],
        ])],
      ])],
      ['C229', new Map([
        ['C229 x 6.8 (229S89-181M)', new Map([
          ['price', 7.35],
          ['weight', 4.6],
        ])],
        ['C229 x 8.0 (229S89-218M)', new Map([
          ['price', 8.81],
          ['weight', 5.4],
        ])],
        ['C229 x 9.4 (229S89-254M)', new Map([
          ['price', 9.65],
          ['weight', 6.3],
        ])],
        ['C229 x 10.7 (229S89-290M)', new Map([
          ['price', 10.44],
          ['weight', 7.2],
        ])],
        ['C229 x 11.9 (229S89-326M)', new Map([
          ['price', 12.21],
          ['weight', 8],
        ])],
      ])],
      ['C254', new Map([
        ['C254 x 5.7 (254S89-144M)', new Map([
          ['price', 7.26],
          ['weight', 3.8],
        ])],
        ['C254 x 7.0 (254S89-181M)', new Map([
          ['price', 8.31],
          ['weight', 4.7],
        ])],
        ['C254 x 8.6 (254S89-218M)', new Map([
          ['price', 9.47],
          ['weight', 5.8],
        ])],
        ['C254 x 10.0 (254S89-254M)', new Map([
          ['price', 10.74],
          ['weight', 6.7],
        ])],
        ['C254 x 11.3 (254S89-290M)', new Map([
          ['price', 11.99],
          ['weight', 7.6],
        ])],
        ['C254 x 12.7 (254S89-326M)', new Map([
          ['price', 13.23],
          ['weight', 8.5],
        ])],
      ])],
      ['C305', new Map([
        ['C305 x 8.0 (305S89-181M)', new Map([
          ['price', 8.95],
          ['weight', 5.4],
        ])],
        ['C305 x 9.5 (305S89-218M)', new Map([
          ['price', 10.31],
          ['weight', 6.4],
        ])],
        ['C305 x 11.0 (305S89-254M)', new Map([
          ['price', 11.72],
          ['weight', 7.4],
        ])],
        ['C305 x 12.5 (305S89-290M)', new Map([
          ['price', 13.09],
          ['weight', 8.4],
        ])],
        ['C305 x 14.0 (305S89-326M)', new Map([
          ['price', 14.48],
          ['weight', 9.4],
        ])],
      ])],
      ['C356', new Map([
        ['C356 x 10.4 (356S89-218M)', new Map([
          ['price', 11.14],
          ['weight', 7],
        ])],
        ['C356 x 12.1 (356S89-254M)', new Map([
          ['price', 12.67],
          ['weight', 8.1],
        ])],
        ['C356 x 13.8 (356S89-290M)', new Map([
          ['price', 13.37],
          ['weight', 9.3],
        ])],
        ['C356 x 15.5 (356S89-326M)', new Map([
          ['price', 16.32],
          ['weight', 10.4],
        ])],
      ])],
    ])],
    [0, new Map([
      ['C6', new Map([
        ['C6 x 2.9 (600S275-57)', new Map([
          ['price', 5.67],
          ['weight', 2.9],
        ])],
        ['C6 x 3.5 (600S275-71)', new Map([
          ['price', 6.59],
          ['weight', 3.5],
        ])],
        ['C6 x 4.0 (600S275-86)', new Map([
          ['price', 7.11],
          ['weight', 4],
        ])],
        ['C6 x 4.7 (600S275-100)', new Map([
          ['price', 8.01],
          ['weight', 4.7],
        ])],
        ['C6 x 5.6 (600S275-114)', new Map([
          ['price', 9.06],
          ['weight', 5.6],
        ])],
        ['C6 x 6.0 (600S275-128)', new Map([
          ['price', 9.78],
          ['weight', 6],
        ])],
      ])],
      ['C8', new Map([
        ['C8 x 3.4 (800S275-57)', new Map([
          ['price', 6.35],
          ['weight', 3.4],
        ])],
        ['C8 x 4.0 (800S275-71)', new Map([
          ['price', 7.06],
          ['weight', 4],
        ])],
        ['C8 x 4.7 (800S275-86)', new Map([
          ['price', 8.08],
          ['weight', 4.7],
        ])],
        ['C8 x 5.4 (800S275-100)', new Map([
          ['price', 8.94],
          ['weight', 5.4],
        ])],
        ['C8 x 6.1 (800S275-114)', new Map([
          ['price', 9.67],
          ['weight', 6.1],
        ])],
        ['C8 x 7.1 (800S275-128)', new Map([
          ['price', 11.28],
          ['weight', 7.1],
        ])],
      ])],
      ['C9', new Map([
        ['C9 x 4.6 (900S350-71)', new Map([
          ['price', 7.35],
          ['weight', 4.6],
        ])],
        ['C9 x 5.4 (900S350-86)', new Map([
          ['price', 8.81],
          ['weight', 5.4],
        ])],
        ['C9 x 6.3 (900S350-100)', new Map([
          ['price', 9.65],
          ['weight', 6.3],
        ])],
        ['C9 x 7.2 (900S350-114)', new Map([
          ['price', 10.44],
          ['weight', 7.2],
        ])],
        ['C9 x 8.0 (900S350-128)', new Map([
          ['price', 12.21],
          ['weight', 8],
        ])],
      ])],
      ['C10', new Map([
        ['C10 x 3.8 (1000S350-57)', new Map([
          ['price', 7.26],
          ['weight', 3.8],
        ])],
        ['C10 x 4.7(1000S350-71)', new Map([
          ['price', 8.31],
          ['weight', 4.7],
        ])],
        ['C10 x 5.8 (1000SS350-86)', new Map([
          ['price', 9.47],
          ['weight', 5.8],
        ])],
        ['C10 x 6.7 (1000S350-100)', new Map([
          ['price', 10.74],
          ['weight', 6.7],
        ])],
        ['C10 x 7.6 (1000S350-114)', new Map([
          ['price', 11.99],
          ['weight', 7.6],
        ])],
        ['C10 x 8.5 (1000S350-128)', new Map([
          ['price', 13.23],
          ['weight', 8.5],
        ])],
      ])],
      ['C12', new Map([
        ['C12 x 5.4 (1200S350-71)', new Map([
          ['price', 8.95],
          ['weight', 5.4],
        ])],
        ['C12 x 6.4 (1200S350-86)', new Map([
          ['price', 10.31],
          ['weight', 6.4],
        ])],
        ['C12 x 7.4 (1200S350-100)', new Map([
          ['price', 11.72],
          ['weight', 7.4],
        ])],
        ['C12 x 8.4 (1200S350-114)', new Map([
          ['price', 13.09],
          ['weight', 8.4],
        ])],
        ['C12 x 9.4 (1200S350-128)', new Map([
          ['price', 14.48],
          ['weight', 9.4],
        ])],
      ])],
      ['C14', new Map([
        ['C14 x 7.0 (1400S350-86)', new Map([
          ['price', 11.14],
          ['weight', 7],
        ])],
        ['C14 x 8.1 (1400S350-100)', new Map([
          ['price', 12.67],
          ['weight', 8.1],
        ])],
        ['C14 x 9.3 (1400S350-114))', new Map([
          ['price', 13.37],
          ['weight', 9.3],
        ])],
        ['C14 x 10.4 (1400S350-128)', new Map([
          ['price', 16.32],
          ['weight', 10.4],
        ])],
      ])],
    ])],
    ["Galvanized ASTM Z90 (G30)", 0.54], // Additive price
    ["Galvanized ASTM Z275 (G90)", 1.4], // Multiplicator
    ["Standard holes", 0.1], // Additive price
  ])],
  ['PurlinsGirtsZ', new Map([
    ["plants", ["Boucherville"]],
    [1, new Map([
      ['Z152', new Map([
        ['Z152 x 4.5 (152Z76-144M)', new Map([
          ['price', 5.67],
          ['weight', 3],
        ])],
        ['Z152 x 5.4 (152Z76-181M)', new Map([
          ['price', 6.59],
          ['weight', 3.6],
        ])],
        ['Z152 x 6.4 (152Z76-218M)', new Map([
          ['price', 7.11],
          ['weight', 4.3],
        ])],
        ['Z152 x 7.6 (152Z76-254M)', new Map([
          ['price', 8.01],
          ['weight', 5.1],
        ])],
        ['Z152 x 8.6 (152Z76-290M)', new Map([
          ['price', 9.06],
          ['weight', 5.8],
        ])],
        ['Z152 x 9.7 (152Z76-326M)', new Map([
          ['price', 9.78],
          ['weight', 6.5],
        ])],
      ])],
      ['Z203', new Map([
        ['Z203 x 5.1 (203Z76-144M)', new Map([
          ['price', 6.35],
          ['weight', 3.4],
        ])],
        ['Z203 x 6.3 (203Z76-181M)', new Map([
          ['price', 7.06],
          ['weight', 4.2],
        ])],
        ['Z203 x 7.3 (203Z76-218M)', new Map([
          ['price', 8.08],
          ['weight', 4.9],
        ])],
        ['Z203 x 8.8 (203Z76-254M)', new Map([
          ['price', 8.94],
          ['weight', 5.9],
        ])],
        ['Z203 x 10.0 (203Z76-290M)', new Map([
          ['price', 9.67],
          ['weight', 6.7],
        ])],
        ['Z305 x 11.2 (203Z76-326M)', new Map([
          ['price', 11.28],
          ['weight', 7.5],
        ])],
      ])],
      ['Z229', new Map([
        ['Z229 x 6.6 (229Z76-181M)', new Map([
          ['price', 7.35],
          ['weight', 4.4],
        ])],
        ['Z229 x 7.7 (229Z76-218M)', new Map([
          ['price', 8.81],
          ['weight', 5.2],
        ])],
        ['Z229 x 9.2 (229Z76-254M)', new Map([
          ['price', 9.65],
          ['weight', 6.2],
        ])],
        ['Z229 x 10.6 (229Z76-290M)', new Map([
          ['price', 10.44],
          ['weight', 7.1],
        ])],
        ['Z229 x 11.9 (229Z76-326M)', new Map([
          ['price', 12.21],
          ['weight', 8],
        ])],
      ])],
      ['Z254', new Map([
        ['Z254 x 6.8 (254Z76-181M)', new Map([
          ['price', 8.31],
          ['weight', 4.6],
        ])],
        ['Z254 x 8.2 (254Z76-218M)', new Map([
          ['price', 9.47],
          ['weight', 5.5],
        ])],
        ['Z254 x 9.8 (254Z76-254M)', new Map([
          ['price', 10.74],
          ['weight', 6.6],
        ])],
        ['Z254 x 11.2 (254Z76-290M)', new Map([
          ['price', 11.99],
          ['weight', 7.5],
        ])],
        ['Z254 x 12.5 (254Z76-326M)', new Map([
          ['price', 13.23],
          ['weight', 8.4],
        ])],
      ])],
      ['Z305', new Map([
        ['Z305 x 7.7 (305Z76-181M)', new Map([
          ['price', 8.95],
          ['weight', 5.2],
        ])],
        ['Z305 x 9.2 (305Z76-218M)', new Map([
          ['price', 10.31],
          ['weight', 6.2],
        ])],
        ['Z305 x 10.9 (305Z76-254M)', new Map([
          ['price', 11.72],
          ['weight', 7.3],
        ])],
        ['Z305 x 12.4 (305Z76-290M)', new Map([
          ['price', 13.09],
          ['weight', 8.3],
        ])],
        ['Z305 x 14.0 (305Z76-326M)', new Map([
          ['price', 14.48],
          ['weight', 9.4],
        ])],
      ])],
    ])],
    [0, new Map([
      ['Z6', new Map([
        ['Z6 x 3.0 (600Z300-57)', new Map([
          ['price', 5.67],
          ['weight', 3],
        ])],
        ['Z6 x 3.6 (600Z300-71)', new Map([
          ['price', 6.59],
          ['weight', 3.6],
        ])],
        ['Z6 x 4.3 (600Z300-86)', new Map([
          ['price', 7.11],
          ['weight', 4.3],
        ])],
        ['Z6 x 5.1 (600Z300-100)', new Map([
          ['price', 8.01],
          ['weight', 5.1],
        ])],
        ['Z6 x 5.8 (600Z300-114)', new Map([
          ['price', 9.06],
          ['weight', 5.8],
        ])],
        ['Z6 x 6.5 (600Z300-128)', new Map([
          ['price', 9.78],
          ['weight', 6.5],
        ])],
      ])],
      ['Z8', new Map([
        ['Z8 x 3.4 (800Z300-57)', new Map([
          ['price', 6.35],
          ['weight', 3.4],
        ])],
        ['Z8 x 4.2 (800Z300-71)', new Map([
          ['price', 7.06],
          ['weight', 4.2],
        ])],
        ['Z8 x 4.9 (800Z300-86)', new Map([
          ['price', 8.08],
          ['weight', 4.9],
        ])],
        ['Z8 x 5.9 (800Z300-100)', new Map([
          ['price', 8.94],
          ['weight', 5.9],
        ])],
        ['Z8 x 6.7 (800Z300-114)', new Map([
          ['price', 9.67],
          ['weight', 6.7],
        ])],
        ['Z8 x 7.5 (800Z300-128)', new Map([
          ['price', 11.28],
          ['weight', 7.5],
        ])],
      ])],
      ['Z9', new Map([
        ['Z9 x 4.4 (900Z300-71)', new Map([
          ['price', 7.35],
          ['weight', 4.4],
        ])],
        ['Z9 x 5.2 (900Z300-86)', new Map([
          ['price', 8.81],
          ['weight', 5.2],
        ])],
        ['Z9 x 6.2 (900Z300-100)', new Map([
          ['price', 9.65],
          ['weight', 6.2],
        ])],
        ['Z9 x 7.1 (900Z300-114)', new Map([
          ['price', 10.44],
          ['weight', 7.1],
        ])],
        ['Z9 x 8.0 (900Z300-128)', new Map([
          ['price', 12.21],
          ['weight', 8],
        ])],
      ])],
      ['Z10', new Map([
        ['Z10 x 4.6 (1000Z300-71)', new Map([
          ['price', 8.31],
          ['weight', 4.6],
        ])],
        ['Z10 x 5.5 (1000Z300-86)', new Map([
          ['price', 9.47],
          ['weight', 5.5],
        ])],
        ['Z10 x 6.6 (1000Z300-100)', new Map([
          ['price', 10.74],
          ['weight', 6.6],
        ])],
        ['Z10 x 7.5 (1000Z300-114)', new Map([
          ['price', 11.99],
          ['weight', 7.5],
        ])],
        ['Z10 x 8.4 (1000Z300-128)', new Map([
          ['price', 13.23],
          ['weight', 8.4],
        ])],
      ])],
      ['Z12', new Map([
        ['Z12 x 5.2 (1200Z300-71)', new Map([
          ['price', 8.95],
          ['weight', 5.2],
        ])],
        ['Z12 x 6.2 (1200Z300-86)', new Map([
          ['price', 10.31],
          ['weight', 6.2],
        ])],
        ['Z12 x 7.3 (1200Z300-100)', new Map([
          ['price', 11.72],
          ['weight', 7.3],
        ])],
        ['Z12 x 8.3 (1200Z300-114)', new Map([
          ['price', 13.09],
          ['weight', 8.3],
        ])],
        ['Z12 x 9.4 (1200Z300-128)', new Map([
          ['price', 14.48],
          ['weight', 9.4],
        ])],
      ])],
    ])],
    ["Galvanized ASTM Z90 (G30)", 0.54], // Additive price
    ["Galvanized ASTM Z275 (G90)", 1.4], // Multiplicator
    ["Standard holes", 0.1], // Additive price
  ])],
]);